import { ScheduledDay, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { scheduledDayClient } from './ScheduledDayClient';

const factory = createStudyEntityHookFactory<ScheduledDay>(StudyEntityType.ScheduledDay);

export const useScheduledDays = factory.list(scheduledDayClient.list);
export const useScheduledDayClone = factory.mutate(scheduledDayClient.clone);
export const useScheduledDayUpdate = factory.mutate(scheduledDayClient.update, {
    optimisticUpdate: (day, days) => days.map(x => (x.id === day.id ? day : x)),
});
export const useScheduledDayDelete = factory.mutate(scheduledDayClient.delete, {
    optimisticUpdate: (day, days) => days.filter(x => x.id !== day.id),
});
export const useScheuledDayModifyCardinality = factory.mutate(scheduledDayClient.modifyCardinality);
